import { AMP_PREFIX } from 'core/site/constants';

const basicSlug = '[a-z0-9-_]+';

export const main = {
  path: '/',
  exact: true,
};

export const faq = {
  path: '/faq',
  exact: true,
};

export const contacts = {
  path: '/contacts',
  exact: true,
};

export const about = {
  path: '/about',
  exact: true,
};

export const search = {
  path: '/search',
  exact: true,
};

export const notFound = {
  path: '/404',
  exact: true,
};

export const error = {
  path: '/error',
  exact: true,
};

export const ai = {
  path: '/ai',
  exact: true,
};

export const topic = {
  path: '/:topic_link([a-z0-9-_/.]+\\.htm)',
};

export const tags = {
  path: `(/journal)?/:tagType(label)/:level_2(${basicSlug})/:level_3(${basicSlug})?`,
  exact: true,
};

export const rubrics = {
  path: `(/journal)?/:level_1(${basicSlug})/:level_2(${basicSlug})?`,
  exact: true,
};

export const topicComments = {
  path: `${topic.path}/comments`,
};

export const mainAmp = {
  path: `/${AMP_PREFIX}`,
  exact: true,
};

export const topicAmp = {
  path: `/${AMP_PREFIX}${topic.path}`,
};

export const rubricsAmp = {
  path: `/amp${rubrics.path}`,
  exact: true,
};

export const tagsAmp = {
  path: `/amp${tags.path}`,
  exact: true,
};

export const files = {
  path: '/([^.]+\\.[0-9a-z]{1,5})(.*)',
};

export const authors = {
  path: '/authors',
  exact: true,
};

export const author = {
  path: `/authors/:level_2(${basicSlug})`,
  exact: true,
};

export const offline = {
  path: '/offline',
  exact: true,
};

export const leaderBoard = {
  path: `${topic.path}/leaderboard`,
};
